.icon-box {
	height: 100%;
	display: flex;
	flex-direction: column;
	padding: var(--mantine-spacing-md);
	overflow: hidden;
	margin-bottom: 0;
	background: var(--docs-card);

	&[data-has-href] {
		cursor: pointer;

		&:hover {
			color: var(--mantine-color-violet-text);
			background: var(--docs-card-hover);

			.description {
				color: var(--mantine-color-text);
			}
		}
	}

	&[data-only-icon] {
		aspect-ratio: 1;
		padding: var(--mantine-spacing-sm);
		align-items: center;
		justify-content: center;
	}
}

a.icon-box {
	text-decoration: none !important;
	color: inherit !important;
}

.unified-icon {
	display: block;
}

.light-icon {
	display: block;

	@include dark {
		display: none;
	}
}

.dark-icon {
	display: none;

	@include dark {
		display: block;
	}
}

.status {
	flex-shrink: 0;
}

.description {
	transition: color 200ms ease;
}

// Light mode draws the edge with a 1px line instead of a fill.
.icon-box {
	@include light {
		border: 1px solid var(--surreal-border-default);
	}
}
